/**
 * Detect Indonesian mobile operator from phone prefix.
 * Logos from product assets (assets/operators/*.png).
 */

const OPERATOR_LOGOS = {
  byu: require('../../assets/operators/byu.png'),
  indosat: require('../../assets/operators/indosat.png'),
  xl: require('../../assets/operators/xl.png'),
  axis: require('../../assets/operators/axis.png'),
  tri: require('../../assets/operators/tri.png'),
  smartfren: require('../../assets/operators/smartfren.png'),
  telkomsel: require('../../assets/operators/telkomsel.png'),
};

const OPERATORS = {
  byu: {
    id: 'byu',
    name: 'by.U',
    short: 'by.U',
    color: '#6EC1E4',
    logo: OPERATOR_LOGOS.byu,
  },
  indosat: {
    id: 'indosat',
    name: 'IM3',
    short: 'IM3',
    color: '#FFD100',
    logo: OPERATOR_LOGOS.indosat,
  },
  xl: {
    id: 'xl',
    name: 'XL',
    short: 'XL',
    color: '#1E22AA',
    logo: OPERATOR_LOGOS.xl,
  },
  axis: {
    id: 'axis',
    name: 'Axis',
    short: 'AXIS',
    color: '#6D2C91',
    logo: OPERATOR_LOGOS.axis,
  },
  tri: {
    id: 'tri',
    name: 'Tri',
    short: '3',
    color: '#F5A26F',
    logo: OPERATOR_LOGOS.tri,
  },
  smartfren: {
    id: 'smartfren',
    name: 'Smartfren',
    short: 'SF',
    color: '#ED1C24',
    logo: OPERATOR_LOGOS.smartfren,
  },
  telkomsel: {
    id: 'telkomsel',
    name: 'Telkomsel',
    short: 'TSEL',
    color: '#ED0226',
    logo: OPERATOR_LOGOS.telkomsel,
  },
};

/** Longer prefixes first so 0851 beats 085, etc. */
const PREFIX_MAP = [
  // by.U (Telkomsel digital brand — common 0851–0853)
  ['0851', 'byu'],
  ['0852', 'byu'],
  ['0853', 'byu'],
  // Telkomsel
  ['0811', 'telkomsel'],
  ['0812', 'telkomsel'],
  ['0813', 'telkomsel'],
  ['0821', 'telkomsel'],
  ['0822', 'telkomsel'],
  ['0823', 'telkomsel'],
  // Indosat / IM3
  ['0814', 'indosat'],
  ['0815', 'indosat'],
  ['0816', 'indosat'],
  ['0855', 'indosat'],
  ['0856', 'indosat'],
  ['0857', 'indosat'],
  ['0858', 'indosat'],
  // XL
  ['0817', 'xl'],
  ['0818', 'xl'],
  ['0819', 'xl'],
  ['0859', 'xl'],
  ['0877', 'xl'],
  ['0878', 'xl'],
  // Axis
  ['0831', 'axis'],
  ['0832', 'axis'],
  ['0833', 'axis'],
  ['0838', 'axis'],
  // Tri
  ['0895', 'tri'],
  ['0896', 'tri'],
  ['0897', 'tri'],
  ['0898', 'tri'],
  ['0899', 'tri'],
  // Smartfren
  ['0881', 'smartfren'],
  ['0882', 'smartfren'],
  ['0883', 'smartfren'],
  ['0884', 'smartfren'],
  ['0885', 'smartfren'],
  ['0886', 'smartfren'],
  ['0887', 'smartfren'],
  ['0888', 'smartfren'],
  ['0889', 'smartfren'],
];

/** Normalize to 08… digits, or empty if not phone-like. */
export function normalizeIdPhoneDigits(value) {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('62')) digits = `0${digits.slice(2)}`;
  else if (!digits.startsWith('0') && digits.length >= 9) digits = `0${digits}`;
  return digits;
}

/**
 * @returns {{ id:string, name:string, short:string, color:string, logo:number }|null}
 */
export function detectMobileOperator(value) {
  const raw = String(value ?? '').trim();
  // Skip non-phone destinations (game id, meter with letters, etc.)
  if (!raw || /[a-zA-Z]/.test(raw)) return null;

  const digits = normalizeIdPhoneDigits(raw);
  if (digits.length < 4) return null;

  for (const [prefix, key] of PREFIX_MAP) {
    if (digits.startsWith(prefix)) {
      return OPERATORS[key] || null;
    }
  }
  return null;
}
